<template>
  <div/>
</template>
<script>
import { vuexOidcProcessSilentSignInCallback } from 'vuex-oidc'

export default {
  mounted(){
    console.log('silent-renew')
    vuexOidcProcessSilentSignInCallback()
    //this.$router.back()
  }
  
}
</script>